export const ListingSkeletonImage = () => (
  <div className="bg-veryLightGray lg:m-0 rounded-4xl xl:rounded-tr-none xl:rounded-br-none
  -mt-12 xl:-mt-0 w-full h-68 xl:w-72 px-10 xl:h-full"></div>
);
